/**
 * @generated SignedSource<<5f5ee63955a82a6a1cde0dd8fcf9b554>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type readingHistoryActionMenuSocialButtonArticle$data = {
  readonly entityId: string;
  readonly entityUuid: string;
  readonly headline: string | null | undefined;
  readonly socialHeadline: string | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentType": "readingHistoryActionMenuSocialButtonArticle";
};
export type readingHistoryActionMenuSocialButtonArticle$key = {
  readonly " $data"?: readingHistoryActionMenuSocialButtonArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"readingHistoryActionMenuSocialButtonArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "readingHistoryActionMenuSocialButtonArticle"
};

(node as any).hash = "f4c88864c5a03b3f32c07b9080058e99";

export default node;
